/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{frame as o,cancelFrame as t}from"../../../frameloop/index.js";import{frameData as r}from"../../../frameloop/data.js";const e=e=>{const m=({timestamp:o})=>e(o);return{start:()=>o.update(m,!0),stop:()=>t(m),now:()=>r.isProcessing?r.timestamp:performance.now()}};export{e as frameloopDriver};
//# sourceMappingURL=driver-frameloop.js.map
